import React from 'react';

const TotalLivingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Total Living</h1>
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600">
            Total Living is our comprehensive residential design service that transforms your living space into a harmonious blend of functionality and aesthetics.
          </p>
          {/* Add more content sections as needed */}
        </div>
      </div>
    </div>
  );
};

export default TotalLivingPage; 